import React, { useEffect } from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { useDispatch } from "react-redux";
import { Creators } from "../../core/redux/ducks/article";
import { useTheme } from "@material-ui/core";
import styled from "styled-components";

export const FeedbackStatus = ({ status, error, statusType }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isShowingStatus = !!(status || error);
  let statusComponent;
  if (status === "adding" || status === "saving") {
    statusComponent = (
      <Text theme={theme} color="primary">
        <img src="images/spinner.gif" width="20" alt="loading" /> {status}
      </Text>
    );
  } else {
    if (status) {
      if (error) {
        statusComponent = (
          <Text theme={theme} color="red">
            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {status}
          </Text>
        );
      } else {
        statusComponent = (
          <Text theme={theme} color="primary">
            <i className="fa fa-check" aria-hidden="true"></i> {status}
          </Text>
        );
      }
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (isShowingStatus) dispatch(Creators.setStatus("", statusType));
    }, 5000);
  }, [status, error]);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={isShowingStatus ? "status" : "empty"}
        addEndListener={(node, done) =>
          node.addEventListener("transitionend", done, false)
        }
        classNames="alert"
        style={{ height: "100%", alignItems: "center", display: "flex" }}
      >
        <FeedbackContainer>
          {isShowingStatus ? statusComponent : <span key="empty"></span>}
        </FeedbackContainer>
      </CSSTransition>
    </SwitchTransition>
  );
};

const Text = styled.span`
  color: ${(props) => (props.color === "primary" ? "#ccc" : props.color)};
`;

const FeedbackContainer = styled.div`
  margin-left: 10px;
`;
